import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import ProductsList from "./ProductsList";

const PRODUCT_TYPE_SUBSIDISED_UUID = '26a41eb6-a9d1-4d2f-88e5-1bb59bdb9ae1';

interface ProductsListWrapperProps {
    defaultToSubsidisedOnly?: boolean;
    excludeSubsidisedFromList?: boolean;
    hideProductTypeFilter?: boolean;
    title?: string;
}

const ProductsListWrapper = ({
    defaultToSubsidisedOnly = false,
    excludeSubsidisedFromList = false,
    hideProductTypeFilter = false,
    title = 'Listado de productos',
}: ProductsListWrapperProps) => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Productos', href: menuRoutes.products.path },
    ];

    const defaultFilters: any = {
        active: true,
    };

    if (defaultToSubsidisedOnly) {
        defaultFilters.product_type = [PRODUCT_TYPE_SUBSIDISED_UUID];
    }

    if (excludeSubsidisedFromList) {
        defaultFilters.exclude_product_type = [PRODUCT_TYPE_SUBSIDISED_UUID];
    }

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title={title} breadcrumb={breadCrumb}>
                    {userCan('create_products', 'products') && (
                        <Button
                            color="primary"
                            onClick={() => { navigate(`${menuRoutes.products.path}/${menuRoutes.products.create}`) }}
                            className={cn(['mt-4 md:mt-0'])}
                        >
                            Crear producto
                        </Button>
                    )}
                </PageHeader>
                <ProductsList
                    forcedProductTypeId={defaultToSubsidisedOnly ? PRODUCT_TYPE_SUBSIDISED_UUID : undefined}
                    forcedExcludedProductTypeId={excludeSubsidisedFromList ? PRODUCT_TYPE_SUBSIDISED_UUID : undefined}
                    hideProductTypeFilter={hideProductTypeFilter}
                />
            </FiltersProvider>
        </Fragment>
    );
}

export default ProductsListWrapper;
